module.exports = __webpack_public_path__ + "img/chamber_door.af3af9b5.jpg";